import type { FormFieldsData } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import { getActivatePositionFillRequestSections } from './activatePositionFillRequestSections';
import activatePositionFillRequestValidation from './activatePositionFillRequestValidation';
import useRecruitmentPoolPositionFillRequestService from 'domain/recruiting/recruitmentPool/useRecruitmentPoolPositionFillRequestService';

type ActivatePositionFillRequestDrawerProps = {
  isOpen: boolean;
  positionFillRequestId: string;
  onClose: () => void;
  onSuccess: () => void;
};

const ActivatePositionFillRequestDrawer = ({
  isOpen,
  positionFillRequestId,
  onClose,
  onSuccess,
}: ActivatePositionFillRequestDrawerProps) => {
  const { attachPositionFillRequest } = useRecruitmentPoolPositionFillRequestService();
  const submitForm = (data: FormFieldsData) =>
    attachPositionFillRequest(data.recruitmentPoolId as string, positionFillRequestId);

  return (
    <CreateEditFormDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Set up recruitment"
      header="Accept the position fill request and assign it to a recruitment pool to start the recruitment process."
      width={620}
      initialData={{ recruitmentPoolId: '' }}
      submitFormFunc={submitForm}
      submitButtonTitle="Accept request"
      getValidationSchemaFunc={() => Promise.resolve(activatePositionFillRequestValidation)}
      handleDirty={false}
      afterSubmit={{
        execute: () => {
          onSuccess();
          onClose();
        },
        message: 'Position fill request has been activated.',
      }}
      getSections={getActivatePositionFillRequestSections}
    />
  );
};

export default ActivatePositionFillRequestDrawer;
